import { FromOptions } from './from-options';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';
import { ManualPaymentEntry } from './manual-payment-entry';
import { Button } from '@/components/ui/button';
import { CsvPaymentEntry } from './csv-payment-entry';

interface CreatePaymentProps {
  from: FromOptions;
  editId?: string;
  coach?: {
    id: string;
    fullNameOrEmail: string;
  };
  'data-testid'?: string;
}

export const CreatePayment = ({ from, editId, coach, 'data-testid': dataTestId }: CreatePaymentProps) => {
  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button className="ml-auto hidden h-8 lg:flex" data-testid={dataTestId}>
            Add payment
            <ChevronDown className="ml-2 h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <ManualPaymentEntry
            from={from}
            coach={coach}
            editId={editId}
            trigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()} data-testid="teacher-payments-menu-item-add">
                Add a payment
              </DropdownMenuItem>
            }
          />
          <CsvPaymentEntry from={from} />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
